// Set config defaults when creating the instance

import axios from "axios";
import { notification } from "antd";
import { apiUrl, localStorageUserKey } from "../../utils/constants";
import { router } from "../router/AppRouter";

let baseURL = apiUrl();

export const http = axios.create({
  baseURL: baseURL,
  timeout: 360000,
  headers: {
    customerid: process.env.CUSTOMER_ID,
  },
});

// Add a response interceptor

http.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    console.log(error);
    if (error?.response?.status === 403) {
    }

    if (error?.response?.status === 401) {
      const errorMessage = error.response.data.errors.message;

      notification.error({
        message: errorMessage,
        duration: 5000,
        description: error.response.data?.errors?.description,
      });

      try {
        if (error.response.data?.action === "clearSession") {
          // Dispatch a custom event
          if (http._logoutUser) {
            http._logoutUser(false);
          }
        } else if (error.response.data?.action === "soft") {
        } else {
          router.navigate("/", { replace: true });
        }
      } catch (e) {
        console.log(e);
      }
    }

    if (error.response.status === 422) {
      notification.error({ message: error.response.data.message });
      router.navigate("/", { replace: true });
    }

    // Do something with response error
    return Promise.reject(error);
  },
);

// Add a response interceptor

export const setAuthorizationHeader = (token = null, logoutUser) => {
  http._logoutUser = logoutUser;

  if (token) {
    http.defaults.headers.common.Authorization = `Token ${token}`;
  } else {
    delete http.defaults.headers.common.Authorization;
  }
};
